import { BUYING_VOLUME_PRODUCT_TYPE } from '../../utils/volumes';

export const BOUGHT_CHART_INTL_KEY = 'app.boughtChart';
export const SALE_CHART_INTL_KEY = 'app.saleChart';

export const CONTRACTED_VOLUME = 'CONTRACT';
export const CURRENTLY_BUYING = BUYING_VOLUME_PRODUCT_TYPE;
export const MONTHLY_VOLUME_BOUGHT = 'MONTH';
export const QUARTERLY_VOLUME_BOUGHT = 'QUARTER';
export const YEARLY_VOLUME_BOUGHT = 'ANNUAL';
